const en_US = {
    info: {
        title: "Ayame Button",
        info: "Info",
        author: "Voice Button United Studio & Nakiri's Izakaya 2020",
        null: "Null",
        subscriber: "Current YouTube Subscribers:",
        audioStaff: "Acknowledgement and Website Info",
        toGithub: "Contact us on GitHub",
        notOfficial: "This is a fan-made website and is not related to Hololive/Cover Corp. Please notify us for removal if you find any uploaded voice lines violate your copyrights: support@vbup.org",
        overlapTips: "Voice lines cannot be paused and lots of threads will be created when playing in Overlap Mode. Please refresh the page occasionally."
    },
    action: {
        toggleNavbar: "Toggle the Navigation Bar",
        random: "● Today's Random Share",
        share: "Share to Twitter",
        placeholder: "Please enter a name",
        live: "● Info Panel",
        vtbbtn: "VTuber Button Catalog",
        close: "Close",
        copy: "Copy",
        stopvoice: "Stop Playing",
        randomplay: "Random Playing",
        overlap: "Overlap Mode",
        autoplay: "Auto Play",
        playing: "Now Playing: ",
        noplay: "",
        adtitle: "● Collaborated Projects",
        weekly: "Fan-made Translations and Illustrations Weekly(In Chinese)",
        plan: "Planned Date: ",
        ing: "Now Streaming:"
    },
    lang: {
        'zh-CN': "简体中文",
        'ja-JP': "日本語",
        'en-US': "English"
    }
}
export default en_US;